import { DoubleButtons } from '@components/BaseModal.styles'
import { Button, FormControlLabel, Radio, RadioGroup, Typography } from '@hermes/web-components'
import { useLocale } from '@hooks/useLocale'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { useUserToken } from '@hooks/useUserToken'
import { addBookToList, addBookToWaitingList } from '@lib/services/user'
import getRegionFromLocale from '@lib/utils/getRegionFromLocale'
import * as React from 'react'
import { AddBookContainer, RadioFormControl } from './Add.styles'

interface AddToListProps {
  bookId: number
  listId?: number
  onClose: () => void
}

const AddToListRoute = ({ bookId, listId, onClose }: AddToListProps) => {
  const [value, setValue] = React.useState('')
  const { token } = useUserToken()
  const { t } = useTranslateMessage()
  const locale = useLocale()
  const region = getRegionFromLocale(locale)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value)
  }

  const addToWaitingList = () =>
    addBookToWaitingList({
      book: bookId,
      type: value as 'not read yet' | 'reading' | 'have read',
      token: String(token),
      country: region.toUpperCase()
    })

  const addToList = () =>
    listId &&
    addBookToList({
      bookId,
      token: String(token),
      listId,
      country: region.toUpperCase()
    })

  return (
    <>
      <AddBookContainer>
        <Typography fontSize="14px">{t({ id: 'modal.addBookToList.add.bookStatus' })}</Typography>
        <RadioFormControl>
          <RadioGroup value={value} onChange={handleChange}>
            <FormControlLabel
              value="have read"
              control={<Radio />}
              label={t({ id: 'modal.addBookToList.add.haveRead' })}
            />
            <FormControlLabel
              value="reading"
              control={<Radio />}
              label={t({ id: 'modal.addBookToList.add.currentlyReading' })}
            />
            <FormControlLabel
              value="not read yet"
              control={<Radio />}
              label={t({ id: 'modal.addBookToList.add.notReadYet' })}
            />
          </RadioGroup>
        </RadioFormControl>
      </AddBookContainer>
      <DoubleButtons>
        <Button
          onClick={() => {
            addToList()
            onClose()
          }}
        >
          {t({ id: 'skip' })}
        </Button>
        <Button
          onClick={() => {
            addToList()
            addToWaitingList()
            onClose()
          }}
          disabled={Boolean(!value.length)}
        >
          {t({ id: 'apply' })}
        </Button>
      </DoubleButtons>
    </>
  )
}

export default AddToListRoute
